import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { List } from '@mui/material';
import ListItemNavLink from '../ListItemNavLink';
import { getMusicDiscographyRoute } from '../../../../router/routes/music/factory/discography';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import { getMusicAlbumsRoute } from '../../../../router/routes/music/factory/album';
import AlbumIcon from '@mui/icons-material/Album';
import { getMusicRecordsRoute } from '../../../../router/routes/music/factory/records';
import MicIcon from '@mui/icons-material/Mic';

const MenuMusic = () => {
	const { t } = useTranslation();

	const selectedRealm = useSelector(state => state.realm.selected);
	const ready = useSelector(state => state.common.ready);
	const artist = useSelector(state => state.artist.artist);

	const disabled = !selectedRealm || !ready || !artist;

	return (
		<List>
			<ListItemNavLink
				tooltip={t('menu_discography')}
				path={getMusicDiscographyRoute()}
				exact={true}
				icon={<LibraryMusicIcon />}
				primary={t('menu_discography')}
				disabled={disabled}
			/>
			<ListItemNavLink
				tooltip={t('menu_album')}
				path={getMusicAlbumsRoute()}
				exact={true}
				icon={<AlbumIcon />}
				primary={t('menu_album')}
				disabled={disabled}
			/>
			<ListItemNavLink
				tooltip={t('menu_record')}
				path={getMusicRecordsRoute()}
				exact={true}
				icon={<MicIcon />}
				primary={t('menu_record')}
				disabled={disabled}
			/>
		</List>
	);
};

export default MenuMusic;
